const defaultState = {
  msg:"",
  redirectUrl:null
};

const unsuccessComponentReducer = (state = defaultState, action) => {
    
  switch (action.type) {
    case "UPDATE_UNSUCCESS_MSG":
      return {
        ...state,
        msg:action.msg,
      };
    case "UPDATE_UNSUCCESS_REDIRECT_URL":
      return {
        ...state,
        redirectUrl:action.redirectUrl || null,
      };
    default:
      return { ...state };
  }
};

export default unsuccessComponentReducer;
